import { appConfig } from "@/constants";
import type { Quest, QuestGroup } from "@ui-kit/QuestList";

const bitpoolQuestQuestsLvl1: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow this game",
    caption: "Get exclusive content",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "ccedb5c9-180d-4b21-b480-9bc264dd5912-wishlist-added",
    ruleId: "ccedb5c9-180d-4b21-b480-9bc264dd5912-wishlist",
  },
  {
    type: "video",
    key: "watch",
    icon: "Play",
    label: "Watch Phase 3 trailer",
    caption: "Learn about what's coming up",
    videoMimeType: "video/mp4",
    videoUrl: `${appConfig.PLAY_ASSETS_CDN_BASE_URL}/videos/bitpool/BitpoolTrailer.mp4`,
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "ccedb5c9-180d-4b21-b480-9bc264dd5912-trailer-event",
    ruleId: "ccedb5c9-180d-4b21-b480-9bc264dd5912-trailer",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow BitPool on X",
    caption: "Don't miss a tweet",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "ccedb5c9-180d-4b21-b480-9bc264dd5912-twitter-event",
    ruleId: "ccedb5c9-180d-4b21-b480-9bc264dd5912-twitter",
  },
  {
    type: "link",
    key: "discord-v2",
    icon: "Discord",
    label: "Join Discord channel",
    caption: "Join our massively growing community",
    linkUrl: "https://discord.com/invite/bAm9qqc2XT",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "ccedb5c9-180d-4b21-b480-9bc264dd5912-discord-event",
    ruleId: "ccedb5c9-180d-4b21-b480-9bc264dd5912-discord",
  },
];

const bitpoolQuestQuestsLvl2: Quest[] = [
  {
    type: "link",
    key: "telegram",
    icon: "Telegram",
    label: "Join Telegram channel",
    caption: "Join our massively growing community",
    linkUrl: "https://t.me/bitsportgaming",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "ccedb5c9-180d-4b21-b480-9bc264dd5912-website-event",
    ruleId: "ccedb5c9-180d-4b21-b480-9bc264dd5912-website",
    waitTimeInHrs: 24,
  },
  {
    type: "custom",
    key: "bonus",
    icon: "ImxRewards",
    label: "Bonus reward",
    caption: "Extra Gems for completing all quests",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "ccedb5c9-180d-4b21-b480-9bc264dd5912-onboarding-event",
    ruleId: "ccedb5c9-180d-4b21-b480-9bc264dd5912-onboarding",
  },
];

export const bitpoolQuests: QuestGroup[] = [
  {
    key: "level-1",
    header: {
      image: "",
      title: "Learn and connect",
      description: "Level 1 Supporter",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +35 <icon> Gems",
    totalGemsGranted: 35,
    hideOnCompletion: true,
    lockedUntilPrevious: true,
    quests: bitpoolQuestQuestsLvl1,
    introModal: {
      title: "You're on your way to Level 1 supporter",
      description:
        "Thanks for following BitPool. Keep showing your support and earn better perks while doing it.",
      foregroundImage:
        "https://images.prismic.io/imtbl-player-portal/Z7bHe57c43Q3f_nc_BP_hero_levels_1.png?auto=format,compress",
    },
  },
  {
    key: "level-2",
    header: {
      image: "",
      title: "Dive deeper",
      description: "Level 2 Believer",
    },
    nextQuest: {
      url: "/games/norma-in-metaland",
      title: "Thanks for getting involved",
      label: "Want more? Check out Norma in Metaland",
      caption: "Earn additional rewards and support more games",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +15 <icon> Gems",
    totalGemsGranted: 15,
    hideOnCompletion: false,
    lockedUntilPrevious: true,
    quests: bitpoolQuestQuestsLvl2,
    introModal: {
      title: "Level 2, here you go",
      description:
        "People like you are making BitPool a better and bigger game. Let's keep at it.",
      foregroundImage:
        "https://images.prismic.io/imtbl-player-portal/Z7bHep7c43Q3f_nb_BP_hero_levels_2.png?auto=format,compress",
    },
    exitModal: {
      title: "That's all folks",
      description:
        "Level 2 Believer achieved. Bigger and better quests are on the horizon!",
      foregroundImage:
        "https://images.prismic.io/imtbl-player-portal/Z7bHeZ7c43Q3f_na_BP_hero_levels_3.png?auto=format,compress",
    },
  },
];
